import { Fragment, useContext } from 'react';
import Line from '../../../components/line/line';
import Spinner from '../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../components/spinner/types/spinnerProps';
import ViewContext from '../../../contexts/viewContext';
import NotificationListItem from './notificationListItem';
import { NotificationListProps } from './types/notificationBadgeProps';

const NotificationList = (props: NotificationListProps) => {
    const { setViewType, viewTypes } = useContext(ViewContext);

    const handleClick = () => {
        props.onClose();
        setViewType(viewTypes.Communication);
    }

    return (<>
        <div className='notification-list-header'>
            <div className='body-txt-large-bold'>Notyfikacje</div>
            <div className='body-txt-small-orange notification-list-btn' onClick={handleClick}>Zobacz wszystkie</div>
        </div>
        {props.loading ? <Spinner spinnerClass={ClassNameSpinner.Big} /> : <div>
            {props.isError && <div className='body-txt-medium badge-notify-error'>Niepowodzenie pobrania danych, spróbuj ponownie później.</div>}
            {props.data.map((d, idx) => {
                return <Fragment key={d.id}>
                    <NotificationListItem active={d.active} text={d.text} epoch={d.epoch} />
                    {idx + 1 !== props.data.length && <div className='notification-line'><Line /></div>}
                </Fragment>
            })}
        </div>
        }
    </>)
}

export default NotificationList;
